import { CATALOG_MODEL_KIND_SYSTEM, EXAM_DEFINITION_KIND } from "@repo/api";
import type { Permissions } from "@repo/auth";

const examCriteria = `ActivityDefinition?_tag=${CATALOG_MODEL_KIND_SYSTEM}|${EXAM_DEFINITION_KIND}`;

/** Recognizes the exam-only grant as well as unrestricted catalog writers. */
export function canWriteExamDefinitions(permissions: Permissions): boolean {
  if (permissions.canWrite("ActivityDefinition")) return true;
  return (
    permissions.accessPolicy?.resource?.some(
      (rule) =>
        rule.resourceType === "ActivityDefinition" &&
        rule.criteria === examCriteria &&
        !rule.compartment &&
        (rule.interaction
          ? rule.interaction.includes("create") && rule.interaction.includes("update")
          : !rule.readonly),
    ) ?? false
  );
}
